import { Nowrap, Text } from '@farmersdog/corgi-x';

export const Tagline = () => (
  <Text as="p" vSpacing="none">
    Our food is made while playing doo-wop tunes, all <Nowrap>with ❤</Nowrap>{' '}
    <Nowrap>in the US</Nowrap>
  </Text>
);
